import React from 'react'
import { Table, TableHead, TableRow, TableBody } from '@material-ui/core'
import {
  TableHeaderUnitCell,
  TableHeaderUnitCellProps,
} from './TableHeaderUnitCell'
import { TableHeaderTitleCell } from './TableHeaderTitleCell'
import { ReportValuesRow, ReportValuesRowProps } from './ReportValuesRow'
import { useReportStyles } from './report-tab-styles'

type Props = {
  title?: string
  caption?: string
  headerCells: TableHeaderUnitCellProps[]
  rows: ReportValuesRowProps[]
}

export function ReportTable({
  title,
  caption,
  headerCells,
  rows,
}: Props): React.ReactElement {
  const classes = useReportStyles()

  return (
    <Table className={classes.table}>
      {caption && <caption>{caption}</caption>}
      <TableHead>
        <TableRow>
          <TableHeaderTitleCell title={title ?? ''} />
          {headerCells.map((cell) => (
            <TableHeaderUnitCell
              key={cell.firstRow ?? cell.secondRow}
              firstRow={cell.firstRow}
              secondRow={cell.secondRow}
              omitPadding={cell.omitPadding || !title}
            />
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <ReportValuesRow
            key={row.title}
            title={row.title}
            values={row.values}
            highlightRow={row.highlightRow}
          />
        ))}
      </TableBody>
    </Table>
  )
}
